import { useForm } from './modules';

export type { ValidateOptions } from './modules';
export { maxLengthRule, requiredRule, requiredRuleName } from './modules/rules';

export default useForm;
